'use client';

import { useAuth } from '../contexts/AuthContext';

export function usePermissions() {
  const { user: contextUser } = useAuth();

  const hasPermission = (permissionId: string): boolean => {
    let user = contextUser;
    if (!user && typeof window !== 'undefined') {
      try {
        const stored = 
          localStorage.getItem('vsys_user') || 
          localStorage.getItem('@vsys:user') || 
          localStorage.getItem('@vsys_pdv_user') ||
          localStorage.getItem('vsys-auth-storage');
        if (stored) {
          const parsed = JSON.parse(stored);
          user = parsed.state?.user || parsed.user || parsed;
        }
      } catch {}
    }

    if (!user) return false;
    
    // Bypass for ADMIN role, MASTER, SUPER ADMIN, ADMINISTRADOR, GERENTE, etc.
    const roleUpper = String(user.role || (user as any).roleName || '').toUpperCase().trim();
    if (
      roleUpper.includes('ADMIN') || 
      roleUpper.includes('SUPER') || 
      roleUpper.includes('MASTER') || 
      roleUpper.includes('GERENTE') || 
      roleUpper.includes('SUPERVISOR') || 
      roleUpper.includes('DIRETOR') || 
      roleUpper.includes('OWNER') || 
      (user as any).isSuperAdmin ||
      (user as any).isAdmin
    ) {
      return true;
    }

    if (!user.permissions || !Array.isArray(user.permissions)) return false;
    
    // SuperAdmin or generic admin wildcard
    if (user.permissions.includes('*')) return true;

    return user.permissions.includes(permissionId);
  };

  return { hasPermission, user: contextUser };
}
